var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9036,7.1823L3.0001,7.1823A3,3 0,0 0,0.0001 10.1823L0.0001,18.0337A3,3 0,0 0,3.0001 21.0337L12.9036,21.0337A3,3 0,0 0,15.9036 18.0337L15.9036,10.1823A3,3 0,0 0,12.9036 7.1823z",
    fill: "#CC4A44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6952,1L7.6952,1A4.1302,4.1302 0,0 0,3.5651 5.1302L3.5651,9.7473A4.1302,4.1302 0,0 0,7.6952 13.8775L7.6952,13.8775A4.1302,4.1302 0,0 0,11.8254 9.7473L11.8254,5.1302A4.1302,4.1302 0,0 0,7.6952 1z",
    fill: "none",
    stroke: "#CC4A44",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.5129de54382b91719c523d6eb7dd5f49.svg";
export { ForwardRef as ReactComponent };